import { Helmet } from 'react-helmet';
import { Fragment } from 'react/jsx-runtime';
import AiReport from 'src/features/AiReport';

const AiReportPage = () => {
  return (
    <Fragment>
      <Helmet title="AI Report" />
      <AiReport />
    </Fragment>
  );
};

export default AiReportPage;
